import { Team } from "../../services/domain/Team";
import { User, UserType } from "../../services/domain/User";
import { roles } from "../roleHelper";

const DEFAULT_USER_TYPE = UserType.AO;

export type UserNewViewModel = User & {
  userTypeStr: string;
  awardingOrgIdStr: string;
  teamIds: string[];
};

export const defaultValues: Partial<UserNewViewModel> = {
  userTypeStr: String(DEFAULT_USER_TYPE),
  userRoles: roles[DEFAULT_USER_TYPE].defaultRoles,
  title: "",
  awardingOrgIdStr: "",
  teamIds: [],
};

export const fromViewModel = (
  viewModel: UserNewViewModel,
  awardingOrgId: number,
  userType: UserType
): User => {
  return {
    ...viewModel,
    awardingOrgId,
    userType,
    userTeams: viewModel.teamIds ? viewModel.teamIds.map((id) => ({ id } as Team)) : [],
  };
};
